import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'filterVenues'
})
export class FilterVenuesPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return value.filter(venueImages => {
      return venueImages.venueType === args;
    });
  }

}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/filter-venues.pipe.ts